import general from './general';
import buruburu from './buruburu';
import footer from './footer';
import fonts from './fonts';
import buttons from './buttons';
import popups from './popups';
import hud from './hud';
import minigames from './minigames';

export type FontName = 'Body' | 'Title' | 'Legal';

export default {
  ...general,
  buruburu,
  minigames,
  footer,
  fonts,
  buttons,
  popups,
  hud,
};
